import { CloseIcon } from '@svgs'
import Link from 'next/link'
import Image from 'next/image'
import styles from './styles.module.scss'
import { ArrowRightIcon } from '@heroicons/react/24/outline'
import { StructuredText } from 'react-datocms/structured-text'
import { ISpeaker } from 'pages/summit'

export const SpeakerDetail = ({
  speaker,
  isPage,
}: {
  speaker: ISpeaker
  isPage?: boolean
}) => (
  <div>
    {!isPage && (
      <div className="flex justify-end">
        <Link
          href="/summit#speakers"
          className="h-10 w-10 hover:bg-primary/10 flex items-center justify-center rounded-sm transition-colors">
          <CloseIcon />
        </Link>
      </div>
    )}

    <div
      className={'grid grid-cols-1 gap-8 md:grid-cols-3 lg:grid-cols-4 mb-10'}>
      {speaker.image && (
        <Image
          className="rounded-xl md:mt-24"
          src={speaker.image.url}
          width={speaker.image.width}
          height={speaker.image.height}
          alt={speaker.name}
        />
      )}

      <div className="md:col-span-2 lg:col-span-3">
        <h1 className="font-bold text-3xl lg:text-4xl">{speaker.name}</h1>
        <h2 className="pb-6 font-bold text-primary text-lg">{speaker.role}</h2>
        {/* <div className={'prose text-xl whitespace-pre-wrap'}>{speaker.bio}</div> */}
        <div className="prose text-xl">
          <StructuredText data={speaker.bio} />
        </div>
        {isPage && (
          <Link
            href="/summit#speakers"
            className="hover:bg-primary/10 text-primary flex items-center justify-center w-fit font-bold rounded-sm transition-colors p-2 gap-2 -ml-2">
            See all speakers <ArrowRightIcon className="h-5 w-5 stroke-2" />
          </Link>
        )}
      </div>
    </div>
  </div>
)
